export default "__VITE_ASSET__b54cab3f__"